// extracted by mini-css-extract-plugin
export var FeaturedProjects = "FeaturedProjects-module--FeaturedProjects--UXwsu";
export var aniSpin = "FeaturedProjects-module--ani-spin--wuLnr";
export var wrapper = "FeaturedProjects-module--wrapper--FgchX";